/**
 * Expected filename format: 'banner-{agentId}-{soldId}-{uuid}.{extension}'
 * Example: 'banner-re_agent_c4PftjdmM8M-sold_4880840333150899097-fa606a2b-d2d5-45a6-a529-0e1afa0fc9cf.png'
 */

export interface BannerParseResult {
  agentId: string;
}

export function parseSoldDealBannerPath(path: string): BannerParseResult | null {
  const filename = path.split('/').pop();
  if (!filename) return null;

  try {
    const parts = filename.split('-');

    if (parts.length < 4) return null; // banner, agentId, soldId, uuid
    if (parts[0] !== 'banner') return null;

    const agentId = parts[1];
    if (!agentId) return null;
    return { agentId };
  }
  catch (error) {
    return null;
  }
}
